import { host } from "utils/externalServiceUtils";

type EdazConfig = {
  [keyof: string]: string | boolean;
};

declare global {
  interface Window {
    edazConfig: EdazConfig;
  }
}

const ENV_PRODUCTION = "Production";

export const parent = window?.edazConfig || {};

// Auth
export const tokenUrl = (parent.REACT_APP_TOKEN_URL || process.env.REACT_APP_TOKEN_URL) as string;
export const grantType = parent.REACT_APP_FLOW || process.env.REACT_APP_FLOW;
export const clientId = (parent.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID) as string;
export const clientSecret = (parent.REACT_APP_CLIENT_SECRET || process.env.REACT_APP_CLIENT_SECRET) as string;
export const scope = (parent.REACT_APP_SCOPE || process.env.REACT_APP_SCOPE) as string;
export const eshopPaymentAPIScope = (parent.REACT_APP_ESHOP_PAYMENT_API_SCOPE ||
  process.env.REACT_APP_ESHOP_PAYMENT_API_SCOPE) as string;
export const accessTokenKey = "Access-token";
export const accessTokenStoreTimestamp = "Access-token-timestamp";

// Sentry
export const sentryDSN = (parent.REACT_APP_SENTRY_DSN || process.env.REACT_APP_SENTRY_DSN) as string;

// Environment
export const environment = (parent.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT) as string;

// Websocket Signal R
export const notificationWsHub = (parent.REACT_APP_NOTIFICATION_WS_HUB || process.env.REACT_APP_NOTIFICATION_WS_HUB) as string;

// Payment gateway
export const paymentGateway = (parent.REACT_APP_PAYMENT_GATEWAY || process.env.REACT_APP_PAYMENT_GATEWAY) as string;

// Localization
export const czechID = (parent.REACT_APP_CZECH_ID ||
  process.env.REACT_APP_CZECH_ID ||
  "3906ba89-153c-4038-8e36-0ca1deb76076") as string;
export const availableLocales = ["cs", "en-GB", "de", "pl", "ru"];
export const czechTimeZone = "Europe/Prague";

// API
export const apiUrl = parent.REACT_APP_API_URL || process.env.REACT_APP_API_URL || host;
export const apiVersion = parent.REACT_APP_API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT || "/";

// ISDS
export const ISDSUrl = (parent.REACT_APP_ISDS_URL || process.env.REACT_APP_ISDS_URL) as string;
export const ISDSAtsId = (parent.REACT_APP_ISDS_ATS_ID || process.env.REACT_APP_ISDS_ATS_ID) as string;

// Sale boundaries
export const START_OF_SALE = (parent.REACT_APP_START_OF_SALE || process.env.REACT_APP_START_OF_SALE) as string;
export const ORDER_ITEM_MAX_COUNT = 50;

// App wide links
export const linkHost = (parent.REACT_APP_GDPR_LINK_HOST ||
  process.env.REACT_APP_GDPR_LINK_HOST ||
  window.location.origin) as string;

// Terms agreement
export const CSTermsAgreementDocumentPath = `${window.location.origin}${
  parent.REACT_APP_TERMS_AGREEMENT_DOCUMENT_PATH_CS || process.env.REACT_APP_TERMS_AGREEMENT_DOCUMENT_PATH_CS
}`;

export const ENTermsAgreementDocumentPath = `${window.location.origin}${
  parent.REACT_APP_TERMS_AGREEMENT_DOCUMENT_PATH_EN || process.env.REACT_APP_TERMS_AGREEMENT_DOCUMENT_PATH_EN
}`;

export const DETermsAgreementDocumentPath = `${window.location.origin}${
  parent.REACT_APP_TERMS_AGREEMENT_DOCUMENT_PATH_DE || process.env.REACT_APP_TERMS_AGREEMENT_DOCUMENT_PATH_DE
}`;

// Google maps
export const googleMapsApiKey = (parent.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY) as string;

// Turnstile
export const turnstileSiteKey = (parent.REACT_APP_TURNSTILE_SITE_KEY || process.env.REACT_APP_TURNSTILE_SITE_KEY) as string;

// Google analytics
export const gaId = (parent.REACT_APP_GA_ID ||
  process.env.REACT_APP_GA_ID ||
  (environment === ENV_PRODUCTION ? "UA-156010888-1" : "UA-156010888-2")) as string;
export const gaDebug: boolean =
  (parent.REACT_APP_GA_DEBUG as boolean) || process.env.REACT_APP_GA_DEBUG === "true" || environment !== ENV_PRODUCTION;

export type KnownErrorCodes = "internalServerError" | "generic";

// Maximální velikost příloh datové schránky = 20MB
export const MAX_FILE_SIZE_IN_BYTES = 20971520;
